import { render, staticRenderFns } from "./SponsorList.vue?vue&type=template&id=1f0b2acc&scoped=true&"
import script from "./SponsorList.vue?vue&type=script&lang=js&"
export * from "./SponsorList.vue?vue&type=script&lang=js&"
import style0 from "./SponsorList.vue?vue&type=style&index=0&id=1f0b2acc&prod&scoped=true&lang=css&"
import style1 from "./SponsorList.vue?vue&type=style&index=1&id=1f0b2acc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0b2acc",
  null
  
)

export default component.exports